import { YodleeQuery } from '@1bill-app/services/yodlee/yodlee.query';
import { YodleeService } from '@1bill-app/services/yodlee/yodlee.service';
import { YodleeAccount } from '@1bill-app/services/yodlee/yodlee.types';
import { animate, style, transition, trigger } from '@angular/animations';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { first } from 'lodash';
import { NGXLogger } from 'ngx-logger';
import { Observable } from 'rxjs';
import { map, mergeMap, tap } from 'rxjs/operators';
import { SubSink } from 'subsink';
/**
 * Page for showing all the bank accounts.
 *
 * URL: /yodlee-accounts
 */
@Component({
  selector: 'app-yodlee-accounts',
  templateUrl: './yodlee-accounts.page.html',
  styleUrls: ['./yodlee-accounts.page.scss'],
  animations: [
    trigger('fadeAnimation', [
      transition(':increment', [style({ opacity: 0 }), animate(600)]),
      transition(':decrement', [style({ opacity: 0 }), animate(600)]),
    ]),
  ],
})
export class YodleeAccountsPage implements OnInit {
  subs = new SubSink();
  public accounts$: Observable<YodleeAccount[]> = this.route.queryParams.pipe(
    mergeMap(param =>
      this.yodleeQuery.accounts$.pipe(
        map(accounts => {
          const type = param['type'];
          if (type) return accounts?.filter(account => account.type === type);
          return accounts;
        }),
        tap((accounts) => {
          const type = param['type'];
          if (type) {
            const account = first(accounts);
            this.groupTitle = account?.displayGroupType;
          }
        }),
      )
    )
  );
  public loading$ = this.yodleeQuery.isLoading$;
  public groupTitle: string = 'Bank accounts';

  // public isPullToRefresh: boolean = false;
  constructor(
    private yodleeQuery: YodleeQuery,
    private logger: NGXLogger,
    private yodleeService: YodleeService,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.subs.sink = this.yodleeService.getAccounts().subscribe();
  }

  doRefresh(event) {
    // this.isPullToRefresh = true;
    this.yodleeService.getAccounts().toPromise().then(() => {
      // this.isPullToRefresh = false;
      event.target.complete();
    }).catch(err => {
      this.logger.log(err);
      event.target.complete();
      // this.isPullToRefresh = false;
    });
  }

}
